<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [dismissableMask]="false"
  [styleClass]="data.isSuccess ? 'success-container' : 'error-container'"
  (onHide)="close()"
  [draggable]="false"
>
  <ng-template pTemplate="header">
    <div class="modal-header">
      <h2>{{ data.title || (data.isSuccess ? "Create User" : "Error") }}</h2>
    </div>
  </ng-template>

  <div class="modal-body">
    <div class="check-icon-image">
      <img
        [src]="
          data.isSuccess ? 'assets/icons/check.svg' : 'assets/icons/warning.svg'
        "
        alt="Popup Icon"
        class="circle-img"
        width="48"
        height="48"
      />
    </div>

    <p class="success-msg" [ngClass]="{ 'error-msg': !data.isSuccess }">
      {{ data.message }}
    </p>

    <ng-container *ngIf="data.isSuccess">
      <div class="info-block">
        <label>User Name:</label>
        <p class="value">{{ data.userName }}</p>
      </div>

      <div class="info-block">
        <label>User Role:</label>
        <p class="value">{{ data.userRole }}</p>
      </div>
    </ng-container>
  </div>

  <ng-template pTemplate="footer">
    <button
      *ngIf="data.isSuccess"
      class="btn-outline"
      (click)="addAnotherUser()"
    >
      Add Another User
    </button>
    <button class="btn-primary" (click)="close()">Close</button>
  </ng-template>
</p-dialog>

<div *ngIf="showCreateUserDialog">
  <app-user-role
    (closeDialog)="showCreateUserDialog = false"
    (roleSelected)="onRoleSelected($event)"
  ></app-user-role>
</div>
